export default "__VITE_ASSET__f7e9b653__"